import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";

import {ILanguageDef, ILanguage} from "../models/ge/language";
import {CONTROL_APP_CONST} from "../../control-app/config/control-app.constant";
import {DANGER_NOTIFY, notify} from "../util/notify.util";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class AppConfigService {

	constructor(private http: HttpClient) {
    }

     /**
     * Load Agency
     *
     * Carga la informacion de la agencia (logos, etc...).
     */
    async loadAgencyLogosAsync()
    {
      let dataRequest = {
            dominio: window.location.hostname
      };
      let urlLogoApp = CONTROL_APP_CONST.URL_LOGO_APP;
      let url = `${CONTROL_APP_CONST.API_URL}AgencyConf`;
      let response = await this.http.post(url, dataRequest).toPromise();
      return response;
    }

}


// WEBPACK FOOTER //
// ./src/app/control-core/services/app-config.service.ts